import { z } from 'zod';
import i18next from 'i18next';
import { emailReminderSchema } from '../email-reminder/email-reminder.schema';

export const globalEmailSettingSchema = z.object({
  id: z.string().optional(),
  token: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('globalEmailSetting:tokenRequired'),
      });
    }
  }),
  emailReminders: z.array(emailReminderSchema).nullish(),
  variableNote: z.string().nullish(),
  active: z.boolean().default(true),
});

export type TGlobalEmailSettingSchema = z.infer<
  typeof globalEmailSettingSchema
>;
